import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const UbicacionesAlmacenamientoFormGroup = ({ iError, iTouched, fIsSubmitting, ubicaciones }) => {
  return (
    <Form.Group>
      <Form.Label
        text='UBIC. ALM.'
        htmlFor='select-ubicacionAlmacenamiento'
        sm={2}
        md={3}
        lg={2}
        alignRightAt='sm'
      />
      <Col sm={10} md={9} lg={10}>
        <Field name='_idUbicacionAlmacenamiento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-ubicacionAlmacenamiento'
            >
              <option value=''>Seleccionar</option>
              {ubicaciones &&
                ubicaciones.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.codigo}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UbicacionesAlmacenamientoFormGroup)
